import { useEffect} from 'react'
export function useOutsideAlerter(ref, ref2, setEdit) {
    useEffect(() => {
      function handleClickOutside(event) {
        if ((ref.current && !ref.current.contains(event.target)) && ref2.current && !ref2.current.contains(event.target)) {
            setEdit(false)
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }